import React from "react";
import API from "../../api/api";
import { errorAlert } from "../../utils/alert";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";

const ExportButtons = ({ table, searchTerm = "" }) => {
  const [loading, setLoading] = React.useState("");

  const handleExport = async (type) => {
    const safeTable = String(table || "")
      .replace(/^\/+|\/+$/g, "")
      .replace(/^"+|"+$/g, "");
    if (!safeTable) return;

    setLoading(type);
    try {
      const res = await API.get(`/admin/export/${safeTable}/${type}`, {
        params: { search: searchTerm || "" },
        responseType: "blob",
      });

      const blob = res?.data;
      if (!blob) throw new Error("Empty export response");

      const disposition =
        res?.headers?.["content-disposition"] ||
        res?.headers?.["Content-Disposition"] ||
        "";

      let filename = `${safeTable}.${type === "excel" ? "xlsx" : "pdf"}`;
      const match = /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/.exec(disposition);
      if (match?.[1]) filename = decodeURIComponent(match[1]);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
      errorAlert("Export failed", err?.message || "Failed to export file");
    } finally {
      setLoading("");
    }
  };

  return (
    <section className="admin-export-panel">
      <div className="admin-export-copy">
        <p className="admin-export-eyebrow">Export</p>
        <p className="admin-export-title">Download filtered data</p>
      </div>
      <div className="admin-export-actions">
        <button
          onClick={() => handleExport("excel")}
          disabled={loading === "excel"}
          className="admin-export-btn is-excel"
        >
          <FaFileExcel aria-hidden="true" />
          {loading === "excel" ? "Exporting..." : "Export Excel"}
        </button>
        <button
          onClick={() => handleExport("pdf")}
          disabled={loading === "pdf"}
          className="admin-export-btn is-pdf"
        >
          <FaFilePdf aria-hidden="true" />
          {loading === "pdf" ? "Exporting..." : "Export PDF"}
        </button>
      </div>
    </section>
  );
};

export default ExportButtons;
